import { Component, OnInit, input } from "@angular/core";

@Component({ standalone: false,
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  currentDate: Date = new Date();
  flush = input(false); // true = strip outer spacing
  constructor() {}

  ngOnInit() {}
}
